<ng-container *ngIf="(isStandalonePage$ | async) === false">
	<header>
		<div class="header-top">
			<div class="container">
				<h1 class="navbar-brand">
					<a [routerLink]="'route.ecsomag-hu.home' | translate">
						<img src="/assets/img/logo-white.svg" width="95" height="32" alt="GLS eCsomag" />
					</a>
				</h1>
				<button
					class="hamburger hamburger--squeeze"
					type="button"
					(click)="isNavbarCollapsed = !isNavbarCollapsed"
					aria-controls="navbarBottomContent"
					[attr.aria-expanded]="!isNavbarCollapsed"
					aria-label="Toggle navigation">
					<span class="hamburger-box">
						<span class="hamburger-inner"></span>
					</span>
				</button>
				<div class="panel">
					<ng-container *ngxLet="user$ | async as user">
						<a *ngIf="!user" [routerLink]="'route.ecsomag-hu.profile.login' | translate" routerLinkActive="active">
							{{ 'header.menu.ecsomag-hu.login' | translate }}
						</a>
						<a *ngIf="user" [routerLink]="'route.ecsomag-hu.profile' | translate">
							<gls-profile-user [user]="user" [style]="'compact'"></gls-profile-user>
						</a>
					</ng-container>

					<div class="language-selector" ngbDropdown>
						<button type="button" class="btn btn-inline btn-link" ngbDropdownToggle id="dropdown-language-select">
							<span [inlineSVG]="'/assets/img/icons/language.svg'" class="icon"></span>
							<span>
								{{ 'header.top.language-select' | translate }}
							</span>
						</button>
						<div ngbDropdownMenu aria-labelledby="dropdown-language-select" class="dropdown-menu dropdown-menu-right">
							<button type="button" ngbDropdownItem (click)="selectLang('hu')">HU</button>
							<button type="button" ngbDropdownItem (click)="selectLang('en')">EN</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div [ngbCollapse]="isNavbarCollapsed" class="header-bottom">
			<div class="container">
				<nav>
					<a [routerLink]="'route.ecsomag-hu.parcel-dispatch' | translate" routerLinkActive="active" (click)="navigateToCalculatorModal($event)">
						{{ 'header.menu.ecsomag-hu.parcel-dispatch' | translate }}
					</a>
					<a [routerLink]="'route.ecsomag-hu.prices' | translate" routerLinkActive="active">
						{{ 'header.menu.ecsomag-hu.prices' | translate }}
					</a>
					<a [routerLink]="'route.ecsomag-hu.contact' | translate" routerLinkActive="active">
						{{ 'header.menu.ecsomag-hu.contact' | translate }}
					</a>
					<a [routerLink]="'route.ecsomag-hu.about-us' | translate" routerLinkActive="active">
						{{ 'header.menu.ecsomag-hu.about-us' | translate }}
					</a>
				</nav>
				<div class="panel">
					<ng-container *ngxLet="user$ | async as user">
						<a *ngIf="!user" [routerLink]="'route.ecsomag-hu.profile.login' | translate" routerLinkActive="active">
							{{ 'header.menu.ecsomag-hu.login' | translate }}
						</a>
						<a *ngIf="user" [routerLink]="'route.ecsomag-hu.profile' | translate">
							<gls-profile-user [user]="user" [style]="'compact'"></gls-profile-user>
						</a>
					</ng-container>

					<div class="language-selector" ngbDropdown>
						<button type="button" class="btn btn-inline btn-link" ngbDropdownToggle>
							<span [inlineSVG]="'/assets/img/icons/language.svg'" class="icon"></span>
							<span>
								{{ 'header.top.language-select' | translate }}
							</span>
						</button>
						<div ngbDropdownMenu aria-labelledby="dropdown-language-select" class="dropdown-menu dropdown-menu-right">
							<button type="button" ngbDropdownItem (click)="selectLang('hu')">HU</button>
							<button type="button" ngbDropdownItem (click)="selectLang('en')">EN</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>

	<ng-container *ngIf="(siteData$ | async)?.announcement as announcement">
		<div class="my-0 p-5 alert alert-warning">
			<div class="d-flex align-items-center justify-content-center">
				<!-- <img src="/assets/img/icons/information2.svg" width="24" height="24" alt=""> -->
				<img
					*ngIf="announcement.icon && icons.getIconUrl(announcement.icon) as iconUrl"
					[src]="iconUrl.src"
					[srcset]="iconUrl.srcset"
					class="icon"
					[style]="icons.fitStyle(announcement.icon, { width: 24, height: 24 })"
					alt="icon" />

				<ng-container *ngIf="announcement.link; else noLink" [ngSwitch]="announcement.link.type">
					<a *ngSwitchCase="'internal'" [routerLink]="announcement.link.url ?? '.'" [fragment]="announcement.link.fragment" class="wysiwyg-content" [innerHTML]="announcement.content"></a>
					<a
						*ngSwitchCase="'external'"
						[href]="announcement.link.url"
						[target]="announcement.link.target || '_blank'"
						rel="noreferrer"
						class="wysiwyg-content"
						[innerHTML]="announcement.content"></a>
					<div *ngSwitchDefault class="wysiwyg-content" [innerHTML]="announcement.content"></div>
				</ng-container>
				<ng-template #noLink>
					<p class="wysiwyg-content" [innerHTML]="announcement.content"></p>
				</ng-template>
			</div>
		</div>
	</ng-container>
</ng-container>

<ng-container *ngIf="(isStandalonePage$ | async) === true">
	<header>
		<div class="header-top">
			<div class="container">
				<a [routerLink]="'route.ecsomag-hu.home' | translate" class="navbar-brand">
					<img src="/assets/img/logo-white.svg" width="95" height="32" alt="GLS eCsomag" />
				</a>
				<div class="panel">
					<div class="language-selector" ngbDropdown>
						<a nohref ngbDropdownToggle id="dropdown-language-select">
							<span [inlineSVG]="'/assets/img/icons/language.svg'" class="icon"></span>
							<span>
								{{ 'header.top.language-select' | translate }}
							</span>
						</a>
						<div ngbDropdownMenu aria-labelledby="dropdown-language-select" class="dropdown-menu dropdown-menu-right">
							<button type="button" ngbDropdownItem (click)="selectLang('hu')">HU</button>
							<button type="button" ngbDropdownItem (click)="selectLang('en')">EN</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</header>
</ng-container>
